import tools from '@/utils/tools';

//保存基本设置接口
const saveConfig = async function(params,that){
  var url = "/backend/setting/saveConfig.html";
  const res = await tools.post(url,params,that);
  return res
}

//获取基本设置接口
const getConfig = async function(params,that){
  var url = "/backend/setting/getConfig.html";
  const res = await tools.post(url,params,that);
  return res
}

//保存支付设置接口
const savePayment = async function(params,that){
  var url = "/backend/setting/savePayment.html";
  const res = await tools.post(url,params,that);
  return res
}

//获取支付设置接口
const getPayment = async function(params,that){
  var url = "/backend/setting/getPayment.html";
  const res = await tools.post(url,params,that);
  return res
}

//保存组图设置接口
const saveImageList = async function(params,that){
  var url = "/backend/setting/saveImageList.html";
  const res = await tools.post(url,params,that);
  return res
}

//获取组图设置接口
const getImageList = async function(params,that){
  var url = "/backend/setting/getImageList.html";
  const res = await tools.post(url,params,that);
  return res
}

//删除组图接口
const delImgList = async function(params,that){
  var url = "/backend/setting/delImgList.html";
  const res = await tools.post(url,params,that);
  return res
}

const settingFunction = {
  saveConfig,
  getConfig,
  savePayment,
  getPayment,
  saveImageList,
  getImageList,
  delImgList,
}

export default settingFunction;


// WEBPACK FOOTER //
// ./src/api/setting.js